import { error } from '@sveltejs/kit';
import { query } from '$app/server';
import { getRequestEvent } from '$app/server';
import { supabaseAdmin } from '#lib/server/supabaseAdmin.js';
import type { StarDistribution } from '~/types';

type Stats = { stars: number; full_clear: boolean; count: number }[];

type DailyStatsParams = {
  stat: string;
  mode: string;
  puzzleId: string | null;
};

export const getDailyStats = query(
  'unchecked',
  async (params: DailyStatsParams): Promise<StarDistribution[]> => {
    const { locals } = getRequestEvent();

    if (!locals.user) error(403, 'not logged in');

    const userId = locals.user.id;

    let stats;
    if (params.stat === 'global') {
      stats = await supabaseAdmin.rpc('get_global_daily_stats_v2', {
        puzzle_id: params.puzzleId,
      });
    } else if (params.stat === 'best') {
      stats = await supabaseAdmin.rpc('get_best_daily_stats', {
        curr_user_id: userId,
        curr_mode: params.mode,
      });
    } else {
      stats = await supabaseAdmin.rpc('get_first_daily_stats', {
        curr_user_id: userId,
        curr_mode: params.mode,
      });
    }

    if (stats.error) error(500, stats.error.message);

    const accum = Array.from({ length: 5 }, () => ({
      true: 0,
      false: 0,
      total: 0,
    }));

    return (stats.data as Stats).reduce((accum, rec) => {
      accum[rec.stars][rec.full_clear ? 'true' : 'false'] = rec.count;
      accum[rec.stars].total += rec.count;
      return accum;
    }, accum) as unknown as StarDistribution[];
  },
);
